import React from 'react';
import PropTypes from 'prop-types';
import {utils, writeFile} from 'xlsx';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData, formatDate, ExcelDateToDateString} from "../../globals/GlobalFunctions";

export interface Props {
    excelData: any;
}

//for mapping elig info to accums record
const memberMap = new Map<string, Array<string>>();

//fixed width accum format
function MedefyAccumFormatter ({excelData}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    try{
        //Check for 2 sheets here - elig and accum
        if (!isEmpty(excelData) && excelData.Sheets.Medefy !== undefined && excelData.Sheets.MedefyAccum !== undefined) {
            let eligSheetDataArray = extractWorkSheetData(excelData.Sheets.Medefy);

            let eligRawCellArray: any[] = eligSheetDataArray[0];

            let eligColumnRange: number = eligSheetDataArray[1];

            let eligRowRange: number = eligSheetDataArray[2];

            let accumSheetDataArray = extractWorkSheetData(excelData.Sheets.MedefyAccum);

            let accumRawCellArray: any[] = accumSheetDataArray[0];

            let accumColumnRange: number = accumSheetDataArray[1];

            let accumRowRange: number = accumSheetDataArray[2];

            const eligValuesIndexCollection = {
                memberSegIndex: eligRawCellArray.indexOf('Member Sequence') + 1,
                //subscriberSSNIndex: rawCellArray.indexOf('Subscriber SSN') + 1,
                altIDIndex: eligRawCellArray.indexOf('Member Alternate ID') + 1,
                fnIndex: eligRawCellArray.indexOf('Member First Name') + 1,
                lnIndex: eligRawCellArray.indexOf('Member Last Name') + 1,
                dobIndex: eligRawCellArray.indexOf('Member Date of Birth') + 1,
                subscriberIndex: eligRawCellArray.indexOf('Subscriber ID') + 1,
                //enrollDateIndex: eligRawCellArray.indexOf('Effective Date') + 1,
                sexIndex: eligRawCellArray.indexOf('Member Gender') + 1,
            }

            const accumValuesIndexCollection = {
                subscriberIndex: accumRawCellArray.indexOf('Subscriber_ID') + 1,
                groupIndex: accumRawCellArray.indexOf('Group_ID') + 1,
                seqIndex: accumRawCellArray.indexOf('Member_Seq') + 1,
                oopIndex: accumRawCellArray.indexOf('Out_Of_Pocket') + 1,
                deducIndex: accumRawCellArray.indexOf('Deductible_Used') + 1,
                fromDateIndex: accumRawCellArray.indexOf('From_Date') + 1,
            }

            let arrayOfMemberArrays: any[] = [];

            for (let i = 1; i < eligRowRange; ++i) {
                let memberArray = [];

                let rowMultiplier = eligColumnRange * i - 1;

                if (eligValuesIndexCollection.altIDIndex > 0){
                    if (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.altIDIndex)].toString().length > 1){
                        memberArray.push(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.altIDIndex)].toString());
                    }
                    else {
                        memberArray.push(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberIndex)].toString().padStart(9, "0") + "01");
                    }

                }
                else {
                    memberArray.push("");
                }

                if (eligValuesIndexCollection.fnIndex > 0){
                    memberArray.push(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.fnIndex)].toString().toUpperCase());
                }
                else {
                    memberArray.push("");
                }

                if (eligValuesIndexCollection.lnIndex > 0){
                    memberArray.push(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.lnIndex)].toString().toUpperCase());
                }
                else {
                    memberArray.push("");
                }

                if (eligValuesIndexCollection.sexIndex > 0){
                    if (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.sexIndex)].toString().toUpperCase() === "MALE"){
                        memberArray.push("M");
                    }
                    else if (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.sexIndex)].toString().toUpperCase() === "FEMALE"){
                        memberArray.push("F");
                    }
                    else {
                        memberArray.push("U");
                    }
                }
                else {
                    memberArray.push("");
                }

                if (eligValuesIndexCollection.dobIndex > 0) {
                    let date = eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.dobIndex)].toString();
                    if (date.includes("/")) {
                        date = formatDate(date);
                    } else if (date.length > 0 && date.length < 6) {
                        date = ExcelDateToDateString(date);
                    }
                    if (date.length > 7) {
                        date = date.replace(/-/g, "");
                    }
                    memberArray.push(date);
                }
                else {
                    memberArray.push("");
                }

                //set elig record by full member ID in map
                memberMap.set(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberIndex)].toString().padStart(9, "0") +
                    eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.memberSegIndex)].toString().padStart(2, "0"), memberArray);
            }

            for (let i = 1; i < accumRowRange; i++) {
                //our member to later be pushed. Oh from what humble origins it begins
                let memberArray: any[] = [];
                let oopMemberString: string = "";
                let deducMemberString: string = "";
                //for each new member array we skip over the previous members determined by the column length, removing 1 to account for our zero based index at the beginning
                let rowMultiplier = accumColumnRange * i - 1;

                //our stored array of elig
                let memberMapArray = memberMap.get(accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.subscriberIndex)].toString().padStart(9, "0") +
                    accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.seqIndex)].toString().padStart(2, "0"));

                if (accumValuesIndexCollection.groupIndex > 0) {
                    oopMemberString += (accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.groupIndex)].toString().padEnd(15, " "));
                    deducMemberString += (accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.groupIndex)].toString().padEnd(15, " "));
                } else {
                    oopMemberString += "               ";
                    deducMemberString += "               ";
                }

                //id
                oopMemberString += memberMapArray ? memberMapArray[0].padEnd(20, " ") : "                    ";
                deducMemberString += memberMapArray ? memberMapArray[0].padEnd(20, " ") : "                    ";

                if (accumValuesIndexCollection.seqIndex > 0) {
                    oopMemberString += accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.seqIndex)].toString().padStart(3, "0");
                    deducMemberString += accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.seqIndex)].toString().padStart(3, "0");
                }

                oopMemberString += " ";
                deducMemberString += " ";

                //out of pocket
                if (accumValuesIndexCollection.oopIndex > 0) {
                    oopMemberString += Number(accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.oopIndex)])
                        .toFixed(2).toString().replace(/\./g, "").padStart(9, "0");
                }

                //deductable
                if (accumValuesIndexCollection.deducIndex > 0) {
                    deducMemberString += Number(accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.deducIndex)])
                        .toFixed(2).toString().replace(/\./g, "").padStart(9, "0");
                }

                if (accumValuesIndexCollection.fromDateIndex > 0) {
                    let date = accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.fromDateIndex)].toString();
                    if (date.includes("/")) {
                        date = formatDate(date);
                    } else if (date.length > 0 && date.length < 6) {
                        date = ExcelDateToDateString(date);
                    }
                    if (date.length > 7) {
                        date = date.replace(/-/g, "");
                    }
                    oopMemberString += date;
                    deducMemberString += date;
                } else {
                    oopMemberString += "        ";
                    deducMemberString += "        ";
                }

                oopMemberString += "O";
                deducMemberString += "D";

                //first name
                oopMemberString += memberMapArray ? memberMapArray[1].padEnd(20, " ") : "                    ";
                deducMemberString += memberMapArray ? memberMapArray[1].padEnd(20, " ") : "                    ";

                //last name
                oopMemberString += memberMapArray ? memberMapArray[2].padEnd(40, " ") : "                                        ";
                deducMemberString += memberMapArray ? memberMapArray[2].padEnd(40, " ") : "                                        ";

                //Sex
                oopMemberString += memberMapArray ? memberMapArray[3] : "";
                deducMemberString += memberMapArray ? memberMapArray[3] : "";

                //date of birth
                oopMemberString += memberMapArray ? memberMapArray[4] : "";
                deducMemberString += memberMapArray ? memberMapArray[4] : "";

                //records for each accum
                if (Number(accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.oopIndex)]) > 0){
                    memberArray.push(oopMemberString);
                    arrayOfMemberArrays.push(memberArray);
                    memberArray = [];
                }

                if (Number(accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.deducIndex)]) > 0){
                    memberArray.push(deducMemberString);
                    arrayOfMemberArrays.push(memberArray);
                    memberArray = [];
                }

            }

            memberMap.clear();

            //create our workbook
            const eligWorkbook = utils.book_new();
            //make the member sheet from our member array of arrays
            let ws1 = utils.aoa_to_sheet(arrayOfMemberArrays, {dateNF: 'mm.dd.yyyy'});

            const today = new Date();

            const month = today.getMonth() + 1;

            let monthString = "";

            let dayString = "";

            if(month < 10){
                monthString = "0" + month.toString();
            }
            else{
                monthString = month.toString();
            }

            const day = today.getDate();

            if(day < 10) {
                dayString = "0" + day.toString();
            }
            else {
                dayString = day.toString();
            }

            const year = today.getFullYear();

            //add it to the new workbook
            utils.book_append_sheet(eligWorkbook, ws1, "Medefy_Accum_" + monthString + dayString + year);
            //it exists and has a sheet send it back to app for export
            if (eligWorkbook && eligWorkbook.SheetNames.includes("Medefy_Accum_" + monthString + dayString + year)) {
                if (!eligWorkbook.Props) eligWorkbook.Props = {};

                //setting the workbook title through props
                eligWorkbook.Props.Title = "Medefy_Accum_" + monthString + dayString + year + ".txt";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(eligWorkbook, "Medefy_Accum_" + monthString + dayString + year + ".txt", {});

                console.log("File Export Complete!");
                setSuccessAlert(true);
            } else {
                setErrorAlert(true);
                console.log("Unknown Export Error!");
            }

            //clear it out at the end in case of rerendering
            excelData.Sheets.Medefy = undefined;
            excelData.Sheets.MedefyAccum = undefined;
        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.Medefy = undefined;
        excelData.Sheets.MedefyAccum = undefined;

    }
    return (
        <div>
            {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                File Download Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
        </div>
    );
}


export default React.memo(MedefyAccumFormatter)

MedefyAccumFormatter.propTypes = {
    excelData: PropTypes.object.isRequired,
};